import React from 'react';
import cn from 'clsx';
import { css } from 'linaria';
import { ModalContent, ModalFooter } from 'fronton-react';
import { ButtonWithGAClickButton, List, ModalHeader, Typography } from 'common/components';
import { INTERIOR_DOORS_ELEMENT_BLOCK } from '../../../../interior-doors-constants';

const servicesModalText = css`
  margin-bottom: 8px;
`;

const servicesModalList = css`
  && {
    li {
      margin-bottom: 0;

      &:not(:last-child) {
        margin-bottom: 4px;
      }
    }
  }
`;

type ServicesProps = {
  onConsultationSignupBtnClick: () => void;
};

export const Services = ({ onConsultationSignupBtnClick }: ServicesProps) => (
  <>
    <ModalHeader title="Услуги Лемана ПРО" />
    <ModalContent>
      <Typography className={servicesModalText} variant="m" size="body_long">
        Мы&nbsp;выполняем все услуги, необходимые для установки двери:
      </Typography>
      <List className={cn(servicesModalText, servicesModalList)} listStyle="disc">
        <li>
          <Typography variant="m" size="body_long">
            замер проёмов: компенсируем стоимость замера при заказе установки;
          </Typography>
        </li>
        <li>
          <Typography variant="m" size="body_long">
            демонтаж старых дверей;
          </Typography>
        </li>
        <li>
          <Typography variant="m" size="body_long">
            сужение/расширение дверных проёмов;
          </Typography>
        </li>
        <li>
          <Typography variant="m" size="body_long">
            врезка петель, замков, дверных ручек и&nbsp;завёрток;
          </Typography>
        </li>
        <li>
          <Typography variant="m" size="body_long">
            монтаж новых дверей любого типа открывания и&nbsp;всей фурнитуры;
          </Typography>
        </li>
        <li>
          <Typography variant="m" size="body_long">
            оформление дверного проёма/портала.
          </Typography>
        </li>
      </List>
      <Typography variant="m" size="body_long">
        Все услуги выполняют проверенные мастера от&nbsp;наших партнёров.
      </Typography>
    </ModalContent>
    <ModalFooter>
      <ButtonWithGAClickButton
        elementBlock={INTERIOR_DOORS_ELEMENT_BLOCK}
        elementName="Записаться на консультацию"
        elementText="Услуги Лемана ПРО"
        onClick={onConsultationSignupBtnClick}
        wide>
        Записаться на консультацию
      </ButtonWithGAClickButton>
    </ModalFooter>
  </>
);
